import { AfterViewInit, Component, Renderer2, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd, NavigationStart } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Location, LocationStrategy } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

// PRELOAD JSON DATA
import { Use, Province, City, District, Prop } from '../../interfaces/prop.interface';
import { PropertiespreService } from '../../services/propertiespre.service';
import { usesJson } from '../../data/uses.json';
// import { provincesJson } from '../../data/provinces.json';

import { Options } from '@angular-slider/ngx-slider';
import { filter, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment.prod';
import { Marker, Map, LngLatLike, Popup } from 'mapbox-gl';
import * as Mapboxgl from 'mapbox-gl';
import { propExtended } from '../../interfaces/propExtended.interface';


@Component({
  selector: 'app-propertiesmain',
  templateUrl: './propertiesmain.component.html',
  styleUrls: ['./propertiesmain.component.scss']
})

export class PropertiesmainComponent implements OnInit, AfterViewInit {

  datosListos: boolean = false;

  startIndex = 0;
  pageSize = 10;
  visibleItems: propExtended[] = [];

  itemsPerPage = 5;
  currentPage = 1;

  reqUrl1: string = '';
  reqUrl2: string = '';

  filteredProvinces: Observable<any> | undefined;
  filteredCities: Observable<any> | undefined;

  selectedIsSearch4: string = '2';
  selectedUse: string = '';
  selectedProvince: Province | undefined;
  selectedCity: City | undefined;
  selectedDistrict: District | undefined;

  uses: Use[] = usesJson;
  provinces: Province[] = []
  cities: City[] = [];
  districts: District[] = [];
  found: number = 0;
  isSearch4: string = '2'; // 1 Venta / 2 Alquiler / 3 Alquiler con opción a venta

  isSearch4Text: any[] = [{
    id: '1',
    name: 'Comprar'
  },
  {
    id: '2',
    name: 'Alquilar'
  }
  ]

  propFound: Prop[] = [];
  propExtend: propExtended[] = []

  mainMap!: Map;
  markers: Marker[] = [];

  rndNum: number = 1;
  orderByValue: string = "";
  viewFilters: boolean = false;
  map_plain: boolean = false;

  generatedComment: string = "";


  firsTime: boolean = true;
  firsTimeProvince: boolean = true;
  firsTimeS4: boolean = true;
  firsTimeCity: boolean = true;
  firsTimeDistrict: boolean = true;

  count = 0;
  count2 = 0;

  helpText: string = "";

  pag: number = 0;

  value: any;
  value2: any;
  value3: any;
  value4: any;
  value5: any;
  value6: any;

  currentMapStyle = 0
  mapStyles: any[] = [{
    name: 'streets-v12'
  },
  {
    name: 'satellite-streets-v12'
  }
  ]

  filterSup: any = {
    surfaceTotalmin: 0,
    surfaceTotalmax: 9000,
    surfacebrmin: 0,
    surfacebrmax: 9000,
    surfacepbmin: 0,
    surfacepbmax: 9000,
    surfaceMezzaninemin: 0,
    surfaceMezzaninemax: 9000,
    surfaceBasement1min: 0,
    surfaceBasement1max: 9000,
    surfaceBasement2min: 0,
    surfaceBasement2max: 9000,
  }
  filterSmoke: any;

  optionsSup: Options = {
    floor: 0,
    ceil: 9000,
    step: 50,
    translate: (value: number): string => {
      return value + 'm²';
    }
  };

  filterForm: FormGroup = this.fb.group({
    ftSupTotal: new FormControl([0, 9000]),
    ftSupBr: new FormControl([0, 9000]),
    smoke: new FormControl(false),
    ftSupMezz: new FormControl([0, 9000]),
    ftSupPb: new FormControl([0, 9000]),
    ftSupBase1: new FormControl([0, 9000]),
    ftSupBase2: new FormControl([0, 9000]),
  })

  supMin = 50
  supMax = 9000

  myForm: FormGroup = this.fb.group({
    isSearch4: [''],
    use: [''],
    province: [''],
    city: [{ value: '', disabled: true }],
    district: [{ value: '', disabled: true }],
  })

  myFormOrder: FormGroup = this.fb.group({
    order: [{ value: '', disabled: false }],
  })

  isSearch4Init: string = '2';
  useInit: string = '';
  provinceInit: string = '';
  cityInit: string = '';
  districtInit: string = '';

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private fb: FormBuilder,
    private propertiespreService: PropertiespreService,
    private _decimalPipe: DecimalPipe,
    private location: Location,
    private locations: LocationStrategy,
    private cookieService: CookieService,
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {
    router.canceledNavigationResolution = 'computed';
    this.location.subscribe(event => {

      if (event.type == "hashchange") {

        if (this.pag > 0) {
          this.pag = this.pag - 1;
          this.router.navigate([''])

        } else {

          this.router.navigate([''])
        }
        // window.location.reload();
      }

    });


    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page

    if (this.cookieService.get('reqUrl')) {


      let url = this.cookieService.get(decodeURIComponent('reqUrl'))
      let url2 = JSON.parse(url)
      this.cookieService.delete('reqUrl')

      this.isSearch4Init = url2['isSearch4'];
      this.useInit = url2['use'];
      this.provinceInit = url2['province']
      this.cityInit = url2['city']
      this.districtInit = url2['district']

    }
    else {

      this.activeRoute.queryParams.subscribe(params => {
        this.isSearch4Init = params['isSearch4'];
        this.useInit = params['use'];
        this.provinceInit = params['province']
        this.cityInit = params['city']
        this.districtInit = params['district']

        if (/^[\],:{}\s]*$/.test(params['supObj'].replace(/\\["\\\/bfnrtu]/g, '@').
          replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
          replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

          //the json is ok
          this.filterSup = JSON.parse(params['supObj'])

        } else {

          //the json is not ok

        }

        this.filterSmoke = params['smoke']
      });
    }
    (Mapboxgl as any).accessToken = environment.mapboxToken;

    // this.propertiespreService.getProvinces().subscribe(provinces => {
    //   this.provinces = provinces.data.provinces;
    // })

    this.propertiespreService.getProvincesByUse(this.isSearch4Init, this.useInit)
      .subscribe({
        next: (data: any) => {

          if (data.length > 0) {
            this.provinces = data;
            this.myForm.get('province')?.enable();
          } else {
            this.provinces = [];
            this.myForm.get('province')?.disable();
          }
        },
        error: (err: any) => { }
      })

    this.propertiespreService.getCitiesByUse(this.provinceInit, this.isSearch4Init, this.useInit)
      .subscribe({
        next: (data: any) => {
          if (data.length > 0) {
            this.cities = data;
            this.myForm.get('city')?.enable();
            this.myForm.setValue({ isSearch4: this.isSearch4Init, use: this.useInit, province: this.provinceInit, city: this.cityInit, district: this.districtInit })
          } else {
            this.cities = []
            this.myForm.get('city')?.disable();
          }
        },
        error: (err: any) => {
          this.cities = []
          this.myForm.get('city')?.disable();
          console.log(err);
        }
      });


  }

  // ==================================================
  // ==================================================
  // ==================================================
  // ==================================================
  // ==================================================

  onScroll() {
    // alert(this.startIndex)
    this.startIndex += this.pageSize;
    // const container = document.querySelector('.scroll-container');
    // const containerHeight = container!.clientHeight || 0;
    // const contentHeight = container!.scrollHeight || 0;
    // const scrollPosition = container!.scrollTop || 0;

    // if (scrollPosition + containerHeight >= contentHeight) {
    //   this.startIndex += this.pageSize;
    // }
  }

  ngAfterViewInit() {
    this.rndNum = Math.floor(Math.random() * 4) + 1
    this.visibleItems = this.propExtend.slice(0, this.pageSize);
    // this.cityInit = ''
    const elements = this.elRef.nativeElement.querySelectorAll('.mat-form-field-infix');
    elements.forEach(element => {
      this.renderer.setStyle(element, 'width', '180px');
      // Puedes agregar más cambios de estilo si lo deseas
    });
  }

  rndGen() {
    return Math.floor(Math.random() * 4) + 1;
  }
  ngOnInit(): void {





    this.mainMap = new Map({
      container: 'mainMap',
      style: 'mapbox://styles/mapbox/streets-v12',
      // style: 'mapbox://styles/mapbox/satellite-v9',
      center: [-3.74922, 40.463667], // [lng, lat]
      zoom: 5
    });

    this.isSearch4 = this.isSearch4Init
    this.uses = this.propertiespreService.getUses();


    // this.cities = this.propertiespreService.getCities(this.provinceInit || '');
    if (this.cities.length > 0) {
      this.myForm.get('city')?.enable();
    } else {
      this.myForm.get('city')?.disable();
      this.myForm.get('district')?.disable();
    }

    // this.districts = this.propertiespreService.getDistricts(this.cityInit || '');

    if (this.districts.length > 0) {
      this.myForm.get('district')?.enable();
    } else {
      this.myForm.get('district')?.disable();
    }


    this.myForm.setValue({
      isSearch4: this.isSearch4Init,
      use: this.useInit,
      province: this.provinceInit,
      city: this.cityInit,
      district: this.districtInit
    })


    this.filterForm.setValue({
      ftSupTotal: this.filterSup?.surfaceTotalmin ? [this.filterSup?.surfaceTotalmin, this.filterSup?.surfaceTotalmax] : [0, 9000],
      ftSupBr: this.filterSup?.surfacebrmin ? [this.filterSup?.surfacebrmin, this.filterSup?.surfacebrmax] : [0, 9000],
      smoke: this.filterSmoke ? this.filterSmoke : false,
      ftSupMezz: this.filterSup?.surface ? [this.filterSup?.surfaceMezzaninemin, this.filterSup?.surfaceMezzaninemax] : [0, 9000],
      ftSupPb: this.filterSup?.surface ? [this.filterSup?.surfacePbmin, this.filterSup?.surfacePbmax] : [0, 9000],
      ftSupBase1: this.filterSup?.surface ? [this.filterSup?.surfaceBase1min, this.filterSup?.surfaceBase1max] : [0, 9000],
      ftSupBase2: this.filterSup?.surface ? [this.filterSup?.surfaceBase2min, this.filterSup?.surfaceBase2max] : [0, 9000]

    })

    this.myForm.statusChanges
      .pipe(
        filter((status: string) => { return this.myForm.valid }))
      .subscribe(() => this.onFormValid());




    OmRangeSlider.init({ inputValueStyle: OmRangeSliderInputValueStyles });



    this.changeisSearch4()
    this.changeUse()
    this.changeProvince()
    this.changeCity()
    this.changeDistrict()

    this.orderBy()

    this.propFind()
    // this.changeProvince()

  }

  // INTERNAL METHODS ////////////////////////////////////////////////////////////

  onPageChange(page: number) {
    this.pag = page;
    let el = document.getElementById('real-state');
    el!.scrollTop = 0;
  }

  changeUse() {

    this.myForm.get('use')?.valueChanges.subscribe(use => {

      if (!this.firsTime) {


        this.propFound = []
        this.propExtend = []
        this.found = 0
        // Limit Provinces to Use an use id

        this.propertiespreService.getProvincesByUse(this.isSearch4, use)
          .subscribe({
            next: (data: any) => {

              if (data.length > 0) {
                this.provinces = data;

                if (!this.provinces.find(el => el.id == this.myForm.get('province')?.value)) {

                  // this.provinces = []

                  // this.myForm.get('province')?.setValue('');
                } else {

                }

                this.myForm.get('province')?.enable();
              } else {
                this.provinces = [];
                this.myForm.get('province')?.disable();
              }
            },
            error: (err: any) => { }
          })
        // alert("changeUse")
        // this.myForm.controls['city'].setValue('');
        this.myForm.get('city')?.disable();

      } else {
        this.firsTime = false
      }

    })



  }

  goPropertyDetail(id: string) {
    let supObj = {
      surfaceTotalmin: this.filterForm.get('ftSupTotal')?.value[0],
      surfaceTotalmax: this.filterForm.get('ftSupTotal')?.value[1],
      surfacebrmin: this.filterForm.get('ftSupBr')?.value[0],
      surfacebrmax: this.filterForm.get('ftSupBr')?.value[1],
      surfacepbmin: this.filterForm.get('ftSupPb')?.value[0],
      surfacepbmax: this.filterForm.get('ftSupPb')?.value[1],
      surfaceMezzaninemin: this.filterForm.get('ftSupMezz')?.value[0],
      surfaceMezzaninemax: this.filterForm.get('ftSupMezz')?.value[1],
      surfaceBasement1min: this.filterForm.get('ftSupBase1')?.value[0],
      surfaceBasement1max: this.filterForm.get('ftSupBase1')?.value[1],
      surfaceBasement2min: this.filterForm.get('ftSupBase2')?.value[0],
      surfaceBasement2max: this.filterForm.get('ftSupBase2')?.value[1],
    }
    let smoke = this.filterForm.get('smoke')?.value;


    this.router.navigate(['/property/' + id],
      {
        queryParams: {
          isSearch4: this.isSearch4,
          use: this.myForm.get('use')?.value,
          province: this.myForm.get('province')?.value,
          city: this.myForm.get('city')?.value,
          district: this.myForm.get('district')?.value,
          uuid: this.propFound.find((prop: Prop) => prop.id === id)?.uuid,
          generatedName: this.propExtend.find((prop: propExtended) => prop.id === id)?.generatedName,
          cityName: this.propExtend.find((prop: propExtended) => prop.id === id)?.cityName,
          districtName: this.propExtend.find((prop: propExtended) => prop.id === id)?.districtName,
          provinceName: this.propExtend.find((prop: propExtended) => prop.id === id)?.provinceName,
          useName: this.propExtend.find((prop: propExtended) => prop.id === id)?.useName,
          supObj: JSON.stringify(supObj),
          smoke: smoke,
          generatedComment: this.propExtend.find((prop: propExtended) => prop.id === id)?.generatedComment
        }
      }
    );
  }

  mapCentre(lat: number, lng: number, zoom: number) {
    this.mainMap.flyTo({
      center: [lng, lat],
      zoom: zoom
    })
  }
  mapCentreProp(lat: number, lng: number) {

    let marker = this.markers.find(marker => marker.getLngLat().lng === lng && marker.getLngLat().lat === lat);


    this.markers.forEach(marker => {
      marker.getElement().getElementsByTagName("path")[0].setAttribute("fill", "#ee7502");
      if (marker.getPopup().isOpen()) marker.getPopup().remove()
    })

    this.mainMap.flyTo({
      center: [lng, lat],
      zoom: 17
    })

    this.markers.forEach(marker => {
      // console.log(marker)
      if (marker.getPopup().isOpen()) marker.getPopup().remove()
    })

    marker = this.markers.find(marker => marker.getLngLat().lng === lng && marker.getLngLat().lat === lat);
    // marker.getElementsByTagName("path")[0].setAttribute("fill", "#cccccc");
    marker.getElement().getElementsByTagName("path")[0].setAttribute("fill", "#444444");
    // marker.togglePopup();
    const el = marker.getElement();
    el.style.color = 'red';




  }

  changeisSearch4() {
    this.myForm.get('isSearch4')?.valueChanges.subscribe(search4 => {
      if (!this.firsTimeS4) {

        // this.helpText = "Seleccione una provincia para ver los inmuebles disponibles"
        // this.propFound = []
        // this.propExtend = []
        // this.found = 0
        // this.provinces = []
        // this.cities = []
        // this.districts = []
        // this.myForm.get('province')?.setValue('');
        // this.myForm.get('city')?.setValue('');
        // this.myForm.get('district')?.setValue('');

        this.propFound = []
        this.propExtend = []
        this.found = 0
        this.pag = 0

        this.propertiespreService.getProvincesByUse(search4, this.myForm.get('use')?.value)
          .subscribe({
            next: (data: any) => {

              if (data.length > 0) {
                this.provinces = data;
                this.myForm.get('province')?.enable();
              } else {
                this.provinces = [];
                this.myForm.get('province')?.disable();
              }
            },
            error: (err: any) => { }
          })
        // alert("changeUse")



        this.isSearch4 = this.myForm.get('isSearch4')?.value
        this.selectedProvince = this.provinces.find(p => p.id == this.myForm.get('province')?.value)

        this.selectedCity = this.cities.find(p => p.id == this.myForm.get('city')?.value)

        this.selectedDistrict = this.districts.find(p => p.id == this.myForm.get('district')?.value)


        if (this.selectedDistrict?.lat && this.selectedDistrict?.lng) {
          this.mapCentre(this.selectedDistrict?.lat, this.selectedDistrict?.lng, 12)
        } else if (this.selectedCity?.lat && this.selectedCity?.lng) {
          this.mapCentre(this.selectedCity?.lat, this.selectedCity?.lng, 12)
        }
        else {
          this.mapCentre(this.selectedProvince?.lat || 40.463667, this.selectedProvince?.lng || -3.74922, 7)
        }

        this.propFind()
        this.paintMarkers()
      } else {
        this.firsTimeS4 = false
      }
    })

  }

  changeProvince() {

    this.myForm.get('province')?.valueChanges.subscribe(province => {
      this.propertiespreService.getCitiesByUse(province, this.isSearch4, this.myForm.get('use')?.value)
        .subscribe({
          next: (data: any) => {
            if (data.length > 0) {
              this.pag = 1
              this.cities = data
              let citiesTemp = data
              // this.cities = []

              this.cities = citiesTemp.filter((city, index, array) => {
                return array.findIndex(p => p.id === city.id) === index;
              });

              if (this.count == 2) {
                this.myForm.get('city')?.setValue('')
              } else {
                this.myForm.get('city')?.setValue(this.cityInit)
                this.count++
              }

              this.myForm.get('city')?.enable();
            } else {
              this.cities = []
              this.myForm.get('city')?.disable();
            }
            this.mapCentre(this.provinces.find(p => p.id == province)?.lat || 40.463667, this.provinces.find(p => p.id == province)?.lng || -3.74922, 8)

          },
          error: (err: any) => {
            this.cities = []
            this.myForm.get('city')?.disable();
            console.log(err);
          }
        });

      if (this.count2 > 1) {
        this.myForm.controls['district'].setValue('');
        this.myForm.get('district')?.disable();
      } else {
        this.count2++;
      }


      this.mapCentre(this.provinces.find(p => p.id == province)?.lat || 40.463667, this.provinces.find(p => p.id == province)?.lng || -3.74922, 8)

    })


  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async clickCity() {
    // await this.delay(1000);
    this.districtInit = ''
    this.myForm.get('district')?.setValue('')
  }

  changeCity() {

    this.myForm.get('city')?.valueChanges.subscribe(city => {
      this.districts = []
      this.pag = 1
      // if (this.districtInit !== '') {
      //   this.myForm.get('district')?.setValue(this.districtInit)
      // }
      // else {
      //   this.myForm.get('district')?.setValue('')
      // }
      let id_province = this.myForm.get('province')?.value
      let id_city = this.myForm.get('city')?.value
      let use = this.myForm.get('use')?.value
      let isSearch4 = this.myForm.get('isSearch4')?.value


      this.propertiespreService.getDistrictsByCity(id_province, isSearch4, use, id_city)
        .subscribe({
          next: (data: any) => {
            if (data.length > 0) {
              // this.districts = []
              this.districts = data;

              this.myForm.get('district')?.enable();
              if (this.districtInit !== '') {
                this.myForm.controls['district'].setValue(this.districtInit);
                this.districtInit = ''
              }


            } else {
              this.districts = []
              this.myForm.get('district')?.disable();
            }
          },
          error: (err: any) => {
            this.districts = []
            this.myForm.get('district')?.disable();
            console.log(err);
          }
        });

      this.mapCentre(this.cities.find(c => c.id == city)?.lat || 40.463667, this.cities.find(c => c.id == city)?.lng || -3.74922, 12)

    })


  }
  changeDistrict() {

    this.myForm.get('district')?.valueChanges.subscribe(district => {
      this.pag = 1
      const districtId = this.myForm.get('district')?.value;
      if (districtId) {
        this.mapCentre(this.districts.find(c => c.id == districtId)?.lat || 40.463667, this.districts.find(c => c.id == districtId)?.lng || -3.74922, 13)
      }
    })
  }

  private onFormValid() {
    this.markers.forEach(marker => marker.remove());
    this.propFind()
  }

  propFind() {
    window.scroll(0, 0);


    this.startIndex = 0;
    let supObj = {
      surfaceTotalmin: this.filterForm.get('ftSupTotal')?.value[0],
      surfaceTotalmax: this.filterForm.get('ftSupTotal')?.value[1],
      surfacebrmin: this.filterForm.get('ftSupBr')?.value[0],
      surfacebrmax: this.filterForm.get('ftSupBr')?.value[1],
      surfacepbmin: this.filterForm.get('ftSupPb')?.value[0],
      surfacepbmax: this.filterForm.get('ftSupPb')?.value[1],
      surfaceMezzaninemin: this.filterForm.get('ftSupMezz')?.value[0],
      surfaceMezzaninemax: this.filterForm.get('ftSupMezz')?.value[1],
      surfaceBasement1min: this.filterForm.get('ftSupBase1')?.value[0],
      surfaceBasement1max: this.filterForm.get('ftSupBase1')?.value[1],
      surfaceBasement2min: this.filterForm.get('ftSupBase2')?.value[0],
      surfaceBasement2max: this.filterForm.get('ftSupBase2')?.value[1],
    }
    let smoke = this.filterForm.get('smoke')?.value;

    let reqUrl = {
      isSearch4: this.myForm.get('isSearch4')?.value,
      use: this.myForm.get('use')?.value,
      province: this.myForm.get('province')?.value,
      city: this.myForm.get('city')?.value,
      district: this.myForm.get('district')?.value
    }




    this.propertiespreService.getProps(supObj, smoke, this.isSearch4, this.myForm.get('use')?.value, this.myForm.get('province')?.value, this.myForm.get('city')?.value, this.myForm.get('district')?.value).subscribe({
      next: (data: any) => {

        this.propFound = data;
        this.found = data.length;
        if (this.found > 0) { this.helpText = '' }
        var filtrado = data.filter(function (objeto) {
          return objeto.status !== "No comercializable - Expropiado (similares)";
        });
        this.propExtend = filtrado;
        this.propFound = filtrado;
        this.found = this.propExtend.length;



        if (this.propExtend.length > 0) {
          this.propExtend.forEach(prop => prop.cityName = this.cities.find(c => c.id == prop.city)?.name)
          this.propExtend.forEach(prop => prop.districtName = this.districts.find(c => c.id == prop.district)?.name)
          this.propExtend.forEach(prop => prop.provinceName = this.provinces.find(c => c.id == prop.province)?.name)
          this.propExtend.forEach(prop => prop.useName = this.uses.find(c => c.id == prop.use)?.name)

          this.propExtend.forEach
            (prop => {
              if (!prop.name) {
                prop.generatedName = this.generateName(prop.id)
              } else {
                prop.generatedName = prop.name
              }
              if (prop.status !== "Comercializable") {
                if (prop.status === "No comercializable - Alquilado - Subarrendado (gestión)" || prop.status === "No comercializable - Alquilado - Arrendado (propiedad)" || prop.status === "No comercializable - Alquilado con opción a compra") {
                  prop.generatedComment = "Alquilado"
                }
                if (prop.status === "No comercializable - Comité" || prop.status === "No comercializable - En legal" || prop.status === "No comercializable - Expropiado (similares)" || prop.status === "Pendiente validación valoración" || prop.status === "Pendiente validación técnica") {
                  prop.generatedComment = "Alquilado"
                }
                if (prop.status === "Vendido") {
                  prop.generatedComment = "Vendido"
                }

              }
              else {
                prop.generatedComment = ""
              }
            })
        }

        this.reqUrl2 = '/inmueblesmain?' + `isSearch4=${this.myForm.get('isSearch4')?.value}&use=${this.myForm.get('use')?.value}&province=${this.myForm.get('province')?.value}&city=${this.myForm.get('city')?.value}&district=${this.myForm.get('district')?.value}&supObj=${JSON.stringify(supObj)}&smoke=${smoke}`

        if (this.reqUrl2 !== this.reqUrl1) {
          this.location.go(this.reqUrl2)
          this.reqUrl1 = this.reqUrl2
        } else {

        }

        this.datosListos = true;
        this.myFormOrder.get('order')?.setValue('');

        this.paintMarkers()
      },
      error: (err: any) => {

      }

    })



  }

  paintMarkers() {
    this.markers.forEach(marker => marker.remove());
    this.markers = [];
    let bounds = new Mapboxgl.LngLatBounds()
    let counter = 0
    this.propFound.forEach(prop => {
      let priceShown = '0'
      if (prop.lat && prop.lng) {
        if (prop.priceVisible) {
          priceShown = this._decimalPipe.transform(prop.askingPriceRent, '1.0-0')! + '€/mes'
        } else {
          // priceShown = 'Consultar precio'
          priceShown = this.propExtend.find(el => el.id == prop.id)?.generatedComment || 'Consultar precio'
        }
        counter = counter + 1

        let supObj = {
          surfaceTotalmin: this.filterForm.get('ftSupTotal')?.value[0],
          surfaceTotalmax: this.filterForm.get('ftSupTotal')?.value[1],
          surfacebrmin: this.filterForm.get('ftSupBr')?.value[0],
          surfacebrmax: this.filterForm.get('ftSupBr')?.value[1],
          surfacepbmin: this.filterForm.get('ftSupPb')?.value[0],
          surfacepbmax: this.filterForm.get('ftSupPb')?.value[1],
          surfaceMezzaninemin: this.filterForm.get('ftSupMezz')?.value[0],
          surfaceMezzaninemax: this.filterForm.get('ftSupMezz')?.value[1],
          surfaceBasement1min: this.filterForm.get('ftSupBase1')?.value[0],
          surfaceBasement1max: this.filterForm.get('ftSupBase1')?.value[1],
          surfaceBasement2min: this.filterForm.get('ftSupBase2')?.value[0],
          surfaceBasement2max: this.filterForm.get('ftSupBase2')?.value[1],
        }
        let smoke = this.filterForm.get('smoke')?.value;

        let image = "assets/img/inmuebles/ejemplo3.jpg"

        if (prop.thumbnail) {
          image = 'https://' + prop.thumbnail
        }



        // let generatedName = this.propExtend.find((prop: propExtended) => id === prop.id)?.generatedName

        let generatedName = this.generateName(prop.id)

        const urlTarget = '/#/property/' + prop.id + '?isSearch4=' + this.isSearch4 + '&use=' + this.myForm.get('use')?.value + '&province=' + this.myForm.get('province')?.value + '&city=' + this.myForm.get('city')?.value + '&district=' + this.myForm.get('district')?.value + '&uuid=' + prop.uuid + '&smoke=' + smoke + '&supObj=' + encodeURIComponent(JSON.stringify(supObj)) + '&generatedName=' + generatedName


        const newMarker = new Marker({ color: '#ee7502', offset: [0, -20] })
          .setLngLat([prop.lng!, prop.lat!])
          .setPopup(new Mapboxgl.Popup({ className: 'prop-popup' })//add popups
            .setHTML('<div class="detail-inm-popup-img"><h5 class="fw-bold priceLoc">' + priceShown + '</h5><a href="' + urlTarget + '"><img src="' + image + '" class="img-full-cover" alt="imagen inmueble"></a></div><div class="detail-inm-popup-text px-3 py-3"><span class="fw-bold nameLoc"><a href="' + urlTarget + '">' + this.propExtend.find(el => el.id == prop.id)?.generatedName + '</a></span><br><p class="streetLoc">' + prop.address + '</p></div>'))
          .addTo(this.mainMap)


        const markerDiv = newMarker.getElement()
        markerDiv.id = 'marker'
        markerDiv.addEventListener('mouseenter', () => newMarker.togglePopup()); //quitar
        markerDiv.addEventListener('mouseleave', () => {
          newMarker.togglePopup() //quitar
        });
        markerDiv.addEventListener('click', () => {
          this.markers.forEach(marker => {
            // console.log(marker)
            marker.getElement().getElementsByTagName("path")[0].setAttribute("fill", "#ee7502");
            if (marker.getPopup().isOpen()) marker.getPopup().remove()
          })
          markerDiv.getElementsByTagName("path")[0].setAttribute("fill", "#444444");
          newMarker.togglePopup()
          this.goPropertyDetail(prop.id); //quitar
        }
        );

        this.markers.push(newMarker);

        this.markers.forEach(marker => {
          bounds.extend(marker.getLngLat())
        })

      } else {
        this.mapCentre(this.provinces.find(c => c.id == this.selectedProvince?.id)?.lat || 40.463667, this.provinces.find(c => c.id == this.selectedProvince?.id)?.lng || -3.74922, 14)
      }
    })
    if (counter > 1) {
      this.mainMap.fitBounds(bounds, { padding: 120 });
    }

  }

  viewMap() {
    var map = document.getElementById("map");
    var orange = document.getElementById("orange-position");
    var list = document.getElementById("list-position");
    var state = document.getElementById("real-state");
    if (map?.style.display !== "" && map?.style.display !== "none") {
      map!.style.display = "none";
      orange!.style.display = "flex";
      list!.style.display = "none";
      state!.style.display = "flex";

    }
    else {
      map!.style.display = "flex";
      orange!.style.display = "none";
      list!.style.display = "flex";
      state!.style.display = "none";
      this.mainMap.setZoom(7)
      this.mainMap.resize()
    }
  }

  changeMapView() {
    this.map_plain = !this.map_plain;
    if (this.currentMapStyle == 0) {
      this.currentMapStyle = 1;
    } else {
      this.currentMapStyle = 0;
    }
    this.mainMap.setStyle('mapbox://styles/mapbox/' + this.mapStyles[this.currentMapStyle].name);
  }

  orderBy() {
    this.myFormOrder.get('order')?.valueChanges.subscribe(order => {
      this.orderByValue = order;
      if (this.orderByValue == 'price1') {
        this.propExtend.sort((a, b) => Number(a.askingPriceRent) - Number(b.askingPriceRent))
      }
      else if (this.orderByValue == 'price2') {
        this.propExtend.sort((b, a) => Number(a.askingPriceRent) - Number(b.askingPriceRent))
      }
      else if (this.orderByValue == 'size1') {
        this.propExtend.sort((b, a) => Number(a.surfaceTotal) - Number(b.surfaceTotal))
      }
      else if (this.orderByValue == 'size2') {
        this.propExtend.sort((a, b) => Number(a.surfaceTotal) - Number(b.surfaceTotal))
      }
    })
  }

  filterSupOptions() {
    this.viewFilters = !this.viewFilters;
  }

  generateName(id: string) {
    let generatedName = ''

    let useName = this.propExtend.find(c => c.id == id)?.useName

    if (useName == "Todos") {
      useName = "Activo"
    }
    // generatedName = useName + ' en ' + this.propExtend.find(c => c.id == id)?.address + ', ' + this.propExtend.find(c => c.id == id)?.cityName + ', ' + this.propExtend.find(c => c.id == id)?.provinceName
    generatedName = useName + ' en ' + this.propExtend.find(c => c.id == id)?.address + ', ' + this.propExtend.find(c => c.id == id)?.cityName

    return generatedName
  }
  displayFnProvince(id): string {
    if (!id) return '';
    let index = this.provinces.findIndex(state => state.id === id);
    return this.provinces[index].name;
  }
  displayFnCity(id): string {
    if (!id) return '';
    let index = this.cities.findIndex(state => state.id === id);
    return this.cities[index].name;
  }

}